module.exports = __webpack_public_path__ + "static/media/avatar.71837029.jpg";